import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import { agencyCustomTabQuestion } from "apiServices/app";
import axios from "axios";
import QuestionComponents from "./QuestionComponents";
import QuestionSkeletonLoaderComponents from "./QuestionSkeletonLoaderComponents";
const AdditionalInformationComponents = ({ clicksData }) => {
  const [questionData, setQuestionData] = useState();
  const [isQuestion, setIsQuestion] = useState(false);
  let firstTabId = clicksData?.custom_tab?.length
    ? clicksData.custom_tab[0].id
    : "";
  const [tabActiveId, setTabActiveId] = useState(firstTabId);

  const getTabDetails = () => {
    let sourceToken = axios.CancelToken.source();

    agencyCustomTabQuestion(
      {
        id: tabActiveId,
        type: 6, // 6 = service provider
        agency_id: clicksData?.agency_id,
        is_service_partner: true,
      },
      sourceToken
    )
      .then(({ data, success }) => {
        if (success === "true") {
          setQuestionData(data);
          setIsQuestion(true);
        }
      })
      .catch()
      .finally(() => {});
    return () => sourceToken.cancel();
  };
  useEffect(() => {
    tabActiveId && getTabDetails();
  }, [tabActiveId]);

  return (
    <>
      {clicksData?.custom_tab?.length ? (
        <>
          <h4 className="conitems__title text-dark fw-bold">
            Additional information
          </h4>
          <Tabs
            activeKey={`tab_info_${tabActiveId}`}
            onSelect={(key) => {
              // Extract the ID from key (remove "tab_info_")
              const id = key.replace("tab_info_", "");
              setTabActiveId(id);
              setQuestionData([]);
              setIsQuestion(false);
            }}
            id="info-tabs"
            className="mb-3"
          >
            {clicksData.custom_tab.map((item, index) => (
              <Tab
                eventKey={`tab_info_${item.id}`}
                title={item.tab_name}
                key={item.id}
              >
                {questionData?.length || isQuestion ? (
                  <QuestionComponents
                    questionData={questionData}
                    tabData={item}
                  />
                ) : (
                  <QuestionSkeletonLoaderComponents count={5} />
                )}
              </Tab>
            ))}
          </Tabs>
        </>
      ) : (
        ""
      )}
    </>
  );
};
AdditionalInformationComponents.propTypes = {
  history: propTypes.object,
};
export default AdditionalInformationComponents;
